export const NAME = 'organizations'
export const ITEMS_PER_PAGE = 5
export const NEED_TO_RE_FILTER_STATISTICS = false
